var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangleOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M1.99019 15.082L8.84427 3.2431C9.22307 2.5888 9.41248 2.26165 9.65959 2.15177C9.87513 2.05593 10.1212 2.05593 10.3368 2.15177C10.5839 2.26165 10.7733 2.5888 11.1521 3.2431L18.0061 15.082C18.3863 15.7386 18.5764 16.0669 18.5483 16.3364C18.5238 16.5715 18.4007 16.785 18.2095 16.924C17.9904 17.0833 17.611 17.0833 16.8522 17.0833H3.1441C2.38533 17.0833 2.00594 17.0833 1.78681 16.924C1.59568 16.785 1.47254 16.5715 1.44803 16.3364C1.41994 16.0669 1.61002 15.7386 1.99019 15.082Z",
    fill: "#DC6803"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99817 7.5V10.8333M9.99817 14.1667H10.0065M8.84427 3.2431L1.99019 15.082C1.61002 15.7386 1.41994 16.0669 1.44803 16.3364C1.47254 16.5715 1.59568 16.785 1.78681 16.924C2.00594 17.0833 2.38533 17.0833 3.1441 17.0833H16.8522C17.611 17.0833 17.9904 17.0833 18.2095 16.924C18.4007 16.785 18.5238 16.5715 18.5483 16.3364C18.5764 16.0669 18.3863 15.7386 18.0061 15.082L11.1521 3.2431C10.7733 2.5888 10.5839 2.26165 10.3368 2.15177C10.1212 2.05593 9.87513 2.05593 9.65959 2.15177C9.41248 2.26165 9.22307 2.5888 8.84427 3.2431Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangleOutlined);
export default __webpack_public_path__ + "893e27946cbaf3c5c626b9affa8be718.svg";
export { ForwardRef as ReactComponent };